/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import Flex from '../Flex';
import { useAdvanceTableContext } from '../../../providers/AdvanceTableSearchProvider';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight } from 'react-icons/fa';

export const AdvanceTableFooter = ({
  viewAllBtn,
  navButtons,
  className,
  rowInfo,
  rowsPerPageSelection,
  rowsPerPageOptions = [5, 10, 15]
}) => {
  const {
    setPageSize,
    previousPage,
    nextPage,
    getCanNextPage,
    getCanPreviousPage,
    getState,
    getPrePaginationRowModel,
    getPaginationRowModel,
    getPageCount,
    setPageIndex,
    getFilteredRowModel
  } = useAdvanceTableContext();

  const {
    pagination: { pageSize, pageIndex }
  } = getState();
  const [perPage] = useState(pageSize);
  const [isAllVisible, setIsAllVisible] = useState(false);

  return (
    <Flex
      className={classNames(
        className,
        'align-items-center justify-content-between'
      )}
    >
      <Flex alignItems="center" className="fs-10">
        {rowInfo && (

          <div className="d-flex align-items-center">
            <span className="me-2">
              Total: {getFilteredRowModel().rows.length} | Página {getState().pagination.pageIndex + 1} de {getPageCount()}
            </span>
            <Form.Control
              type="number"
              min="1"
              max={getPageCount()}
              value={getState().pagination.pageIndex + 1}
              onChange={e => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                setPageIndex(page);
              }}
              style={{ width: '70px', height: '31px' }}
              size="sm"
            />
          </div>

          // <p className="mb-0">

          //   <span className="d-none d-sm-inline-block me-2">
          //     {pageSize * pageIndex + 1} hasta{' '}
          //     {pageSize * pageIndex + getPaginationRowModel().rows.length} de{' '}
          //     {getPrePaginationRowModel().rows.length}
          //   </span>
          //   {viewAllBtn && (
          //     <>
          //       <span className="d-none d-sm-inline-block me-2">&mdash;</span>
          //       <Button
          //         variant="link"
          //         size="sm"
          //         className="py-2 px-0 fw-semibold"
          //         onClick={() => {
          //           setIsAllVisible(!isAllVisible);
          //           setPageSize(
          //             isAllVisible
          //               ? perPage
          //               : getPrePaginationRowModel().rows.length
          //           );
          //         }}
          //       >
          //         View {isAllVisible ? 'less' : 'all'}
          //         <FontAwesomeIcon
          //           icon="chevron-right"
          //           className="ms-1 fs-11"
          //         />
          //       </Button>
          //     </>
          //   )}
          // </p>
        )}
        {/* {rowsPerPageSelection && (
          <>
            <p className="mb-0 mx-2">Filas por página:</p>
            <Form.Select
              size="sm"
              className="w-auto"
              onChange={e => setPageSize(Number(e.target.value))}
              defaultValue={pageSize}
            >
              {rowsPerPageOptions.map(value => (
                <option value={value} key={value}>
                  {value}
                </option>
              ))}
            </Form.Select>
          </>
        )} */}
      </Flex>
      {navButtons && (
        <Flex>

          <Button
            variant="outline-dark"
            size="sm"
            className="mx-1"
            onClick={() => setPageIndex(0)}
            disabled={!getCanPreviousPage()}
          >
            {/* &laquo; Primera */}
            <FaAngleDoubleLeft />
          </Button>

          <Button
            size="sm"
            variant={getCanPreviousPage() ? 'outline-dark' : 'tertiary-dark'}
            onClick={() => previousPage()}
            className={classNames('mx-1', {
              disabled: !getCanPreviousPage(),
            })}
          >
            <FaAngleLeft />
          </Button>



          {/* Mostrar números de página (5 páginas alrededor de la actual) */}
          {(() => {
            // Determinar qué páginas mostrar
            let pagesArray = [];
            if (getPageCount() <= 5) {
              // Si hay 5 o menos páginas, mostrarlas todas
              pagesArray = Array.from({ length: getPageCount() }, (_, i) => i);
            } else if (getState().pagination.pageIndex <= 2) {
              // Si estamos en las primeras páginas
              pagesArray = [0, 1, 2, 3, 4];
            } else if (getState().pagination.pageIndex >= getPageCount() - 3) {
              // Si estamos en las últimas páginas
              pagesArray = [
                getPageCount() - 5,
                getPageCount() - 4,
                getPageCount() - 3,
                getPageCount() - 2,
                getPageCount() - 1
              ];
            } else {
              // Estamos en medio, mostrar 2 antes y 2 después
              pagesArray = [
                getState().pagination.pageIndex - 2,
                getState().pagination.pageIndex - 1,
                getState().pagination.pageIndex,
                getState().pagination.pageIndex + 1,
                getState().pagination.pageIndex + 2
              ];
            }

            return pagesArray.map(pageNum => (
              <Button
                key={`page-${pageNum}`}
                variant={pageNum === getState().pagination.pageIndex ? "primary" : "outline-dark"}
                size="sm"
                className="mx-1"
                onClick={() => setPageIndex(pageNum)}
              >
                {pageNum + 1}
              </Button>
            ));
          })()}

          <Button
            size="sm"
            variant={getCanNextPage() ? 'outline-dark' : 'tertiary-dark'}
            className={classNames('mx-1', {
              disabled: !getCanNextPage()
            })}
            onClick={() => nextPage()}
          >
            <FaAngleRight />
          </Button>

          <Button
            variant="outline-dark"
            size="sm"
            className="mx-1"
            onClick={() => setPageIndex(getPageCount() - 1)}
            disabled={!getCanNextPage()}
          >
            {/* Última &raquo; */}
            <FaAngleDoubleRight />
          </Button>

        </Flex>
      )}
    </Flex>
  );
};

export default AdvanceTableFooter;
